import React, { useState } from "react"
import { NavButton } from "../navbutton/navbutton"
import styles from "./navbar.module.css"
import { graphql, useStaticQuery } from "gatsby"
import { extractServiceName } from "../../utils/paths"
import { MenuIcon } from "../icons"
import { ContactPanel } from "../contact-panel/contact-panel"
export default () => {
  let [navOpen, setNavOpen] = useState(false)

  let {
    allContentfulCountyPage: counties,
    allContentfulContentPage: services,
  } = useStaticQuery(
    graphql`
      query countyDropdownQuery {
        allContentfulCountyPage {
          nodes {
            countyName
          }
        }
        allContentfulContentPage(filter: { isServicePage: { eq: true } }) {
          nodes {
            title
          }
        }
      }
    `
  )

  return (
    <>
      <button className={styles.openBtn} onClick={() => setNavOpen(true)}>
        <MenuIcon color={"white"} />
      </button>
      <div
        className={`${styles.sidenav} ${
          navOpen ? styles.opened : styles.closed
        }`}
      >
        <button className={styles.closebtn} onClick={() => setNavOpen(false)}>
          &times;
        </button>
        <NavButton
          to={"/"}
          label={"Home"}
          dropDownValues={counties.nodes.map(node => ({
            ...node,
            countyName: node.countyName + " county",
          }))}
        />
        <NavButton to={"about"} label={"About"} />
        <NavButton
          label={"Services"}
          dropDownValues={services.nodes.map(node => ({
            ...node,
            countyName: extractServiceName(node.title),
          }))}
        />
        <NavButton to={"contact"} label={"Contact"} />
        <NavButton to={"cities-we-service"} label={"Cities we Service"} />
        <NavButton to={"blog"} label={"Blog"} />
        <NavButton to={"prices"} label={"Pricing"} />
        <ContactPanel />
      </div>
    </>
  )
}
